import { useState, ChangeEvent } from 'react';
import { Event, Price, BursaryOption } from "@/types/checkout/checkout";

export const useBursaryState = (event: Event | null, prices: Price[], selectedOption: string) => {
    const [requestBursary, setRequestBursary] = useState<boolean>(false);
    const [bursaryMessage, setBursaryMessage] = useState<string>('');
    const [bursaryAmount, setBursaryAmount] = useState<string>('');
    const [selectedBursaryOption, setSelectedBursaryOption] = useState<BursaryOption | null>(null);
    const [bursaryError, setBursaryError] = useState<string>('');

    const handleBursaryAmountChange = (e: ChangeEvent<HTMLInputElement>) => {
        const amount = e.target.value;
        setBursaryAmount(amount);
        
        if (amount && selectedOption) {
            const selectedPrice = prices.find(p => p.stripe_price_id === selectedOption);
            if (selectedPrice) {
                const ticketPrice = selectedPrice.unit_amount / 100;
                const bursaryAmountFloat = parseFloat(amount);
                
                if (bursaryAmountFloat > ticketPrice) {
                    setBursaryError(`Bursary amount cannot exceed ticket price ($${ticketPrice})`);
                } else if (bursaryAmountFloat < 0) {
                    setBursaryError('Bursary amount cannot be negative');
                } else {
                    setBursaryError('');
                }
            }
        } else {
            setBursaryError('');
        }
    };

    const handleBursaryOptionSelect = (option: BursaryOption) => {
        if (selectedOption) {
            const selectedPrice = prices.find(p => p.stripe_price_id === selectedOption);
            if (selectedPrice) {
                const ticketPrice = selectedPrice.unit_amount / 100;
                if (option.amount > ticketPrice) {
                    setBursaryError(`Bursary amount cannot exceed ticket price ($${ticketPrice})`);
                    return;
                }
            }
        }
        setSelectedBursaryOption(option);
        setBursaryAmount(option.amount.toString());
        setBursaryError('');
    };

    const handleBursaryMessageChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        const message = e.target.value;
        setBursaryMessage(message);
        
        // Clear any existing bursary error when user is typing
        if (bursaryError && bursaryError.includes('bursary request')) {
            setBursaryError('');
        }
    };

    const resetBursaryState = () => {
        setBursaryAmount('');
        setBursaryMessage('');
        setSelectedBursaryOption(null);
        setBursaryError('');
    };

    return {
        requestBursary,
        setRequestBursary,
        bursaryMessage,
        setBursaryMessage,
        bursaryAmount,
        bursaryError,
        setBursaryError,
        selectedBursaryOption,
        handleBursaryAmountChange,
        handleBursaryOptionSelect,
        handleBursaryMessageChange,
        resetBursaryState
    };
}; 